export default class SingleServiceController {
	constructor() {
		this.initialized = false;
	}

	init() {
		if (this.initialized || !this.shouldRun()) {
			return;
		}

		this.initialized = true;
		this.fadeInBanner();
		this.bindModalTriggers();
		this.bindBannerCollapse();
		this.bindConsultingPopup();
		this.wrapResponsiveTables();
	}

	shouldRun() {
		return Boolean(
			document.getElementById('banner_service')
			|| document.getElementById('banner_service_collapse')
			|| document.querySelector('.modal__single_service')
			|| document.querySelector('.single__section .postsingle__left')
		);
	}

	fadeInBanner() {
		window.setTimeout(() => {
			const bannerService = document.getElementById('banner_service');
			if (bannerService) {
				bannerService.style.opacity = '1';
			}
		}, 3000);
	}

	bindModalTriggers() {
		document.querySelectorAll('.open-modal-btn').forEach((button) => {
			button.addEventListener('click', () => {
				const targetSelector = button.getAttribute('data-target');
				const modal = targetSelector ? document.querySelector(targetSelector) : null;

				if (!modal) {
					return;
				}

				modal.style.display = 'block';
				window.setTimeout(() => modal.classList.add('show'), 10);
			});
		});

		document.querySelectorAll('.close__single_service').forEach((button) => {
			button.addEventListener('click', () => {
				const modal = button.closest('.modal__single_service');
				this.closeModal(modal);
			});
		});

		document.querySelectorAll('.modal__single_service').forEach((modal) => {
			modal.addEventListener('click', (event) => {
				if (event.target === modal) {
					this.closeModal(modal);
				}
			});
		});
	}

	bindBannerCollapse() {
		document.getElementById('close-button')?.addEventListener('click', () => {
			const banner = document.getElementById('banner_service');
			const collapsedBanner = document.getElementById('banner_service_collapse');

			if (banner) {
				banner.style.display = 'none';
			}

			if (collapsedBanner) {
				collapsedBanner.style.display = 'block';
			}
		});

		document.getElementById('open-button')?.addEventListener('click', () => {
			const banner = document.getElementById('banner_service');
			const collapsedBanner = document.getElementById('banner_service_collapse');

			if (banner) {
				banner.style.display = 'block';
			}

			if (collapsedBanner) {
				collapsedBanner.style.display = 'none';
			}
		});
	}

	bindConsultingPopup() {
		document.querySelectorAll('.mobi-show, .pc-show').forEach((element) => {
			element.addEventListener('click', (event) => {
				event.preventDefault();
				const modalOverlay = document.getElementById('modalOverlayt3');
				if (modalOverlay) {
					modalOverlay.classList.add('active-popup-t3');
				}
			});
		});
	}

	wrapResponsiveTables() {
		const contentArea = document.querySelector('.single__section .postsingle__left');

		if (!contentArea) {
			return;
		}

		contentArea.querySelectorAll('table').forEach((table) => {
			if (table.parentElement?.classList.contains('table-responsive')) {
				return;
			}

			table.classList.add('table', 'table-bordered');

			const wrapper = document.createElement('div');
			wrapper.className = 'table-responsive';

			table.parentNode.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		});
	}

	closeModal(modal) {
		if (!modal) {
			return;
		}

		modal.classList.remove('show');
		window.setTimeout(() => {
			modal.style.display = 'none';
		}, 500);
	}
}
